


















































import EmailAssetDialog from '@/components/common/EmailAssetDialog.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ASSET_URL } from '../../common/config';
import BrandAsset from '../../common/model/BrandAsset';
import brandModule from '../../store/modules/brand.module';
import errorModule from '../../store/modules/error.module';

@Component({
  components: {
    EmailAssetDialog,
  },
})
export default class BrandSectionCard extends Vue {
  @Prop() asset!: BrandAsset;

  cdnUrl = ASSET_URL;

  placeholderImg = require('@/assets/admin/placeholder.jpg');

  imageFailedToLoad = false;

  get secondaryColor(): string {
    return '#000000';
  }

  get imageSrc(): string {
    if (this.asset.webp_url && !this.imageFailedToLoad) {
      // Asset is an image, return the compressed image.
      return `${this.cdnUrl}${this.asset.webp_url}`;
    }
    // If there is no full_size_url, nothing is set
    if (this.asset.full_size_url) {
      if (!this.imageFailedToLoad) {
        return '';
      }
      return `${this.cdnUrl}${this.asset.full_size_url}`;
    }
    return '';
  }

  get fileType(): string {
    const fileName: string = this.asset.full_size_url;
    const dotIndex = fileName.lastIndexOf('.');
    const fileType = fileName.substring(dotIndex + 1).toUpperCase();
    if (fileType.length > 5) {
      // File is invalid, do not display.
      return '';
    }
    return fileType;
  }

  failedToLoadImage(): void {
    this.imageFailedToLoad = true;
  }

  async shareAsset(recipientEmail: string): Promise<void> {
    const payload = { assetId: this.asset.id, recipientEmail };
    await brandModule.emailBrandAsset(payload);
    if (errorModule.hasError) {
      errorModule.clearError();
    }
  }
}
